import { StoreKeys } from '../useStore/state';
import { useStore } from '../useStore/useStore';

export function useIsNiceMember(): boolean {
  const memberInfo = useStore(StoreKeys.OBAPI_MEMBERS);
  const member = memberInfo?.[0];
  const isUspNiceMember = member?.isUspNiceMember;
  const isEniNiceMember = member?.isEniNiceMember;

  return isUspNiceMember || isEniNiceMember;
}
